<template>
  <div class="time-separator">
    <div class="separator-line"></div>
    <div class="separator-text">{{ timeText }}</div>
    <div class="separator-line"></div>
  </div>
</template>

<script>
export default {
  name: 'TimeSeparator',
  props: {
    timestamp: {
      type: [Date, String],
      required: true
    }
  },
  computed: {
    timeText() {
      if (!this.timestamp) return '';
      
      const date = new Date(this.timestamp);
      const now = new Date();
      const diff = now - date;
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));

      if (days === 0) {
        return 'Today';
      } else if (days === 1) {
        return 'Yesterday';
      } else if (days < 7) {
        return date.toLocaleDateString([], { weekday: 'long' });
      } else {
        return date.toLocaleDateString([], { 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        });
      }
    }
  }
};
</script>

<style scoped>
.time-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px 0;
  position: relative;
}

.separator-line {
  flex: 1;
  height: 1px;
  background-color: #e0e0e0;
  max-width: 100px;
}

.separator-text {
  background-color: #f0f2f5;
  color: #666;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 4px 12px;
  border-radius: 12px;
  margin: 0 16px;
  white-space: nowrap;
  text-transform: capitalize;
}

@media (max-width: 600px) {
  .separator-line {
    max-width: 60px;
  }
  
  .separator-text {
    font-size: 0.7rem;
    padding: 3px 8px;
    margin: 0 8px;
  }
}
</style>
